import React, { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { localize } from "../../../common/services/localization"
import { PaymentImage, ProductImage, SizedImage } from "../ui/file-contents"
import { Popup } from "./popup"
import { SubscribeGlobalState } from "../../../common/hooks/global-state"
import { ProductsRepository } from "../../../api/repositories/stats/products"
import { Product } from "../../../api/repositories/stats/models/products"
import { isNothing } from "../../../common/utils"
import { PaymentsRepository } from "../../../api/repositories/backend/payments"
import { BlueButton, OrangeButton } from "../functional/buttons"
import { Input } from "../functional/inputs"

export const PaymentPatreonPopup: React.FC<{}> = props => {
    const language = SubscribeGlobalState("language")
    const authorized = SubscribeGlobalState("authorizedUser")
    const [searchParams, setSearchParams] = useSearchParams()
    const productId = searchParams.get("productId") as PopupType

    const [response, setResponse] = useState<ApiDataResponse<Product>>()

    useEffect(() => {
        const repository = new ProductsRepository();

        repository.get(productId)
            .then(t => setResponse(t));
    }, [])

    let url: string | undefined = undefined

    if (response && !!!response.hasErrors) {
        if (language === "ru") {
            url = response.data?.extraData?.rubLotUrl
        } else {
            url = response.data?.extraData?.usdLotUrl
        }
    }

    if (!productId || !authorized || !authorized.authorized) {
        searchParams.delete("popup")
        setSearchParams(searchParams)

        return <></>
    }

    return (
        <Popup>
            <div className="flex flex-col items-center gap-[32px]">
                <div className="w-full flex flex-col items-center text-[16px]">
                    <div className="w-full max-w-[655px] text-center font-['Roboto']"
                        dangerouslySetInnerHTML={{ __html: localize("payment_patreon_description") }} />
                </div>
                <div className="flex flex-col px-[32px] py-[24px] w-full bg-dark-sm text-[18px] font-semibold">
                    <div dangerouslySetInnerHTML={{ __html: localize("payment_uah_id").replace("%id%", authorized.playerId) }} />
                    <div dangerouslySetInnerHTML={{ __html: localize("payment_uah_funpay").replaceAll("%url%", "https://www.patreon.com/ShardsShop") }} />
                </div>
                <PaymentImage
                    className="w-[655px]"
                    name={`patreon_${language || "en"}`}
                />
            </div>
        </Popup>
    )
}

export const PaymentFunPayPopup: React.FC<{}> = props => {
    const language = SubscribeGlobalState("language")
    const authorized = SubscribeGlobalState("authorizedUser")
    const [searchParams, setSearchParams] = useSearchParams()
    const productId = searchParams.get("productId") as PopupType

    const [response, setResponse] = useState<ApiDataResponse<Product>>()

    useEffect(() => {
        const repository = new ProductsRepository();

        repository.get(productId)
            .then(t => setResponse(t));
    }, [])

    let url: string | undefined = undefined

    if (response && !!!response.hasErrors) {
        if (language === "ru") {
            url = response.data?.extraData?.rubLotUrl
        } else {
            url = response.data?.extraData?.usdLotUrl
        }
    }

    console.log(language);
    console.log(response?.data);
    console.log(response?.data?.extraData);


    if (!productId || !authorized || !authorized.authorized) {
        searchParams.delete("popup")
        setSearchParams(searchParams)

        return <></>
    }

    return (
        <Popup>
            <div className="flex flex-col items-center gap-[32px]">
                <div className="w-full flex flex-col items-center text-[16px]">
                    <div className="w-full max-w-[943px] text-center font-['Roboto']"
                        dangerouslySetInnerHTML={{ __html: localize("payment_uah_description") }} />
                </div>
                <div className="flex flex-col px-[32px] py-[24px] w-full bg-dark-sm text-[18px] font-semibold">
                    <div dangerouslySetInnerHTML={{ __html: localize("payment_uah_id").replace("%id%", authorized.playerId) }} />
                    <div dangerouslySetInnerHTML={{ __html: localize("payment_uah_funpay").replaceAll("%url%", url || `/?popup=notice&noticeCode=${1}`) }} />
                </div>
                <PaymentImage
                    className="w-[630px]"
                    name={`funpay_${language || "en"}`}
                />
            </div>
        </Popup >
    )
}

const PaymentMethodButton: React.FC<{
    productId: string
    sym: string
    desc: string
    disabled?: boolean
    onClick: () => void
}> = props => {
    return (
        <button
            disabled={props.disabled || false}
            className={`px-[12px] py-[37px] text-[48px] uppercase font-semibold payment-method-bg`}
            onClick={props.onClick}
        >
            {props.sym}
        </button>
    )
}

export const PaymentMethodPopup = () => {
    const paymentsRepository = new PaymentsRepository();

    const [details, setDetails] = React.useState(false)
    const [confirmRules, setConfirmRules] = React.useState(true)
    const [autoSub, setAutoSub] = React.useState(true)

    const [searchParams, setSearchParams] = useSearchParams()
    const productId = searchParams.get("productId") as PopupType

    if (isNothing(productId)) {
        clearSearchParams(searchParams);
        setSearchParams(searchParams)

        return <></>
    }

    const isDotaPlusProduct = productId.includes("dota_plus");

    return (
        <Popup>
            <div className="flex flex-col items-center">
                <div className="text-[44px] font-semibold"
                    dangerouslySetInnerHTML={{
                        __html: localize(`payment_product_${productId}`)
                    }}
                >
                </div>
                <div className="mt-[35px] text-[16px] uppercase font-semibold ">
                    {localize("payment_select_method")}
                </div>
                <div className="mt-[18px] flex grid grid-cols-1 sm:grid-cols-3 gap-[25px] items-center justify-center">
                    <PaymentMethodButton productId={productId} sym="Карта РФ" desc="payment_method_rub"
                        disabled={!confirmRules} onClick={() =>
                            paymentsRepository.createOrder({
                                currency: 'rub',
                                productId: productId,
                                type: 'Default',
                                turnOnAutoSub: autoSub
                            }).then((response) => {
                                if (!response.hasErrors)
                                    window.open(response.data?.url!);
                                else
                                    alert(response.errors[0].text);
                            })
                        }
                    />
                    <PaymentMethodButton productId={productId} sym="FunPay" desc="" onClick={() => {
                        searchParams.set("popup", "payment_funpay")
                        setSearchParams(searchParams)
                    }} />
                    <PaymentMethodButton productId={productId} sym="Patreon" desc="" onClick={() => {
                        searchParams.set("popup", "payment_patreon")
                        setSearchParams(searchParams)
                    }} />
                </div>
                {
                    isDotaPlusProduct
                        ? <div className="w-full mt-[36px]">
                            <button
                                className="mt-2 w-full h-16 bg-dark-sm bg-opacity-15 hover:bg-white hover:bg-opacity-25 text-center 
                                font-semibold text-[24px] text-gray text-shadow-xl"
                                onClick={() => setDetails(!details)}
                            >
                                {localize("payment_details_button")}
                            </button>
                            <div className={`w- full ${details ? "" : "max-h-0 invisible"} overflow-y-hidden border-t-2 border-gray-600 flex flex-col  `}>
                                <div className="mt-4">
                                    <div>
                                        <input type="checkbox" className="mr-2"
                                            defaultChecked={confirmRules}
                                            onChange={() => setConfirmRules(!confirmRules)}
                                        />
                                        <label>
                                            {localize("payment_checkbox_approve")}
                                        </label>
                                    </div>
                                    <div className="mt-6">
                                        <Input
                                            className="w-[300px] lg:w-[400px]"
                                            placeholderLocal={"payment_email_notification"}
                                        />
                                    </div>
                                </div>
                                <a className="mt-10 text-center" href="/docs/tinkoff_offer_payments.pdf" target="__blank">
                                    <u>
                                        {localize("payment_offer_payments")}
                                    </u>
                                </a>
                                <a className="text-center" href="/docs/tinkoff_offer_user.pdf" target="__blank">
                                    <u>
                                        {localize("payment_offer_user")}
                                    </u>
                                </a>
                            </div>
                        </div>
                        : <></>
                }
            </div>
        </Popup>
    )
}

const BuyShardsButton: React.FC<{
    productId: string
    price: number
    amount: number
    currency: Currency
    discount?: number
}> = props => {
    const [searchParams, setSearchParams] = useSearchParams()
    const discount = props.discount ? props.discount.toString() : ""

    return (
        <div className="flex flex-col items-center justify-self-center self-center relative bg-dark-sm w-[217px] hover:border-orange hover:scale-[110%]">
            <div className="flex justify-center">
                <ProductImage
                    className="w-full "
                    imgClassName="w-full"
                    name={props.productId}
                />
                {discount !== "" ?
                    <div className="absolute top-0 right-0 bg-green text-right px-[10px] py-[6px] 
                                 font-['Roboto'] font-semibold text-[16px] w-auto">
                        {`-${discount}%`}
                    </div>
                    : <></>
                }
            </div>
            <div className="flex flex-col gap-[40px] pt-[18px] pb-[14px]">
                <div className="font-semibold uppercase text-[16px]">
                    {localize("buy_shards_product_desc").replace("%amount%", props.amount.toString())}
                </div>
                <OrangeButton
                    className="font-semibold px-[15px] py-[10px] "
                    textClassName="text-[18px] font-semibold"
                    localText={localize("buy_shards_price_desc").replace("%price%", props.price.toString())}
                    onClick={() => {
                        searchParams.set("popup", "payment_method")
                        searchParams.set("productId", props.productId)
                        setSearchParams(searchParams)
                    }}
                />
            </div>
        </div>
    )
}

export const BuyShardsPopup = () => {
    const language = SubscribeGlobalState("language")

    const [response, setResponse] = useState<ApiDataResponse<Product[]>>()

    useEffect(() => {
        const repository = new ProductsRepository();

        repository.getShards()
            .then(t => setResponse(t));
    }, [])

    let currency: Currency = "usd"

    if (language === "ru") {
        currency = "rub"
    }

    return (
        <Popup>
            <div className="flex flex-col text-center">
                <div className="text-[36px] font-semibold uppercase tracking-wider">
                    {localize("buy_shards_title")}
                </div>
                <div
                    className="font-semibold text-[16px] mt-[25px]"
                    dangerouslySetInnerHTML={{ __html: localize("buy_shards_desc") }}
                />
                <div className="mt-[30px] flex flex-col justify-center items-center justify-center grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-[25px]">
                    {
                        response && !!!response.hasErrors && response.data?.map(s =>
                            <BuyShardsButton
                                productId={s.productId}
                                price={s.prices[currency]}
                                currency={currency}
                                amount={s.amount}
                                discount={s.extraData?.discount}
                            />
                        )
                    }
                </div>
            </div>
        </Popup>
    )
}

const BuyDotaPlusButton: React.FC<{
    productId: string
    price: number
    currency: Currency
    discount?: number
}> = props => {
    const [searchParams, setSearchParams] = useSearchParams()
    const discount = props.discount ? props.discount.toString() : ""

    return <div className="flex flex-col items-center justify-self-center self-center relative bg-dark-sm w-[217px] hover:scale-[110%]">
        <div className="flex justify-center pt-[6px]">
            <ProductImage
                className="w-full"
                imgClassName="w-full"
                name={props.productId}
            />
            {discount !== "" ?
                <div className="absolute top-0 right-0 bg-green text-right px-[10px] py-[6px] 
                                font-['Roboto'] font-semibold text-[16px] w-auto">
                    {`-${discount}%`}
                </div>
                : <></>
            }
        </div>
        <div className="flex flex-col gap-[40px] pt-[18px] pb-[14px]">
            <div className="font-semibold uppercase text-[16px]">
                {localize(`buy_product_${props.productId}`)}
            </div>
            <OrangeButton
                className="font-semibold px-[15px] py-[10px] font-['Roboto']"
                textClassName="text-[18px] font-semibold"
                localText={localize("buy_shards_price_desc").replace("%price%", props.price.toString())}
                onClick={() => {
                    searchParams.set("popup", "payment_method")
                    searchParams.set("productId", props.productId)
                    setSearchParams(searchParams)
                }}
            />
        </div>
    </div>
}

export const BuyDotaPlusPopup = () => {
    const language = SubscribeGlobalState("language")

    const [response, setResponse] = useState<ApiDataResponse<Product[]>>()

    useEffect(() => {
        const repository = new ProductsRepository();

        repository.getDotaPlus()
            .then(t => setResponse(t));
    }, [])

    let currency: Currency = "usd"

    if (language === "ru") {
        currency = "rub"
    }

    return (
        <Popup>
            <div className="flex flex-col text-center">
                <div className="text-[36px] font-semibold uppercase tracking-wider">
                    {localize("buy_dota_plus_title")}
                </div>
                <div className="mt-[30px] grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-[25px]">
                    {
                        response && !!!response.hasErrors && response.data?.map(s =>
                            <BuyDotaPlusButton
                                productId={s.productId}
                                price={s.prices[currency]}
                                currency={currency}
                                discount={s.extraData?.discount}
                            />
                        )
                    }
                </div>
            </div>
        </Popup>
    )
}

function clearSearchParams(params: URLSearchParams): URLSearchParams {
    params.delete("popup")
    params.delete("productId")
    params.delete("heroName")
    params.delete("talentName")
    params.delete("present")
    params.delete("present_history")

    return params;
}